/**
 * Soft I1b: the summary-card view (state only — never a route / query / hash).
 * Reuses the share card node renderSummary builds as-is, then the screen-only
 * review breakdown and one row: [되돌리기][공유].
 */
import { t } from '../../i18n/strings'
import { backFromSummaryCard, getState, openShareFromSummaryCard } from '../../state'
import { el } from '../dom'
import { renderReviewBreakdown } from '../reviewBreakdown'
import { renderSummary } from './summary'

/**
 * Soft I1b: input finished (river or an earlier fold) → the summary is the
 * share card itself — the very node renderSummary builds (same content, same
 * order as the share preview), with nothing above it (no title / hint /
 * banner / icon) and one row below: [되돌리기][공유]. No toast, no confirm.
 */
function findByClass(node: Element, cls: string): HTMLElement | null {
  for (const c of Array.from(node.children ?? [])) {
    if (String(c.className ?? '').split(/\s+/).includes(cls)) return c as HTMLElement
    const hit = findByClass(c, cls)
    if (hit) return hit
  }
  return null
}

export function renderSummaryCardView(): HTMLElement {
  const ui = t()
  const card = findByClass(renderSummary(), 'shareCard')!
  // Screen-only review breakdown, always open, under the card (summary-card view only).
  const review = renderReviewBreakdown(getState().hand)
  return el('section', { className: 'panel panelSummary panelSummaryCard', attrs: { 'data-soft-i1b': 'summary-card' } }, [
    card,
    review,
    el('div', { className: 'summaryCardNav' }, [
      el('button', {
        className: 'btn btnQuiet navPrevBtn',
        attrs: { type: 'button', 'data-soft-i1b': 'back' },
        text: ui.undo,
        on: { click: () => backFromSummaryCard() },
      }),
      el('button', {
        className: 'btn btnQuiet endHereBtn',
        attrs: { type: 'button', 'data-soft-i1b': 'share' },
        text: ui.step.summary,
        on: { click: () => openShareFromSummaryCard() },
      }),
    ]),
  ])
}
